/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-12-07 22:21:59
 */
/* eslint-disable */
import fetchHelper from '../../utils/fetchHelper'
import exceptionHelper from '../../utils/exceptionHelper'
import { captureFetchException } from '../../utils/sentryUtils'
import type { AppDispatch, RootState } from '../../app/store'

interface PhotoListParams {
  filter: {
    times: Array<{ start: string; end: string }>
    labels: string[]
  }
  groupID: string
  lastPageCond: string
}

interface PhotoLabelsParams {
  groupID: string
}

export const getPhotoList = (data: PhotoListParams) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/photo/ai/search',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result: any) => exceptionHelper(result))
      .catch((err: any) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export const getPhotoLabels = (data: PhotoLabelsParams) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/photo/ai/search/labels',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result: any) => exceptionHelper(result))
      .catch((err: any) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}
